import { reactive } from 'vue';

/**
 * 财税实战课堂 V0.3 原型（学员端）共享状态。
 * 数据与交互逻辑自交互原型 index.html 原样迁移，全部为示例数据，不请求外部接口。
 * 与教师端（renhe_platform_front）的 store.js 同源；本文件仅保留学员端用到的部分。
 */

// ===== 问题与投票话题 =====
export const topics = [
  { id: 'all', label: '全部问题', group: '一起看见真实需求', prompt: '这节课，你最想解决什么问题？' },
  { id: 'lesson', label: '这节课最想解决什么问题？', group: '本节课 · 真实需求', prompt: '这节课，你最想解决什么问题？' },
  { id: 'work', label: '工作中，你正面临什么问题？', group: '工作现场 · 真问题', prompt: '工作中，哪件事正让你感到棘手？' },
  { id: 'enterprise', label: '企业财务管理最大的卡点？', group: '企业现场 · 财务管理', prompt: '走进企业做财务管理，你遇到的最大卡点是什么？' },
  { id: 'ai', label: '最想用 AI 解决什么问题？', group: 'AI 实战 · 应用需求', prompt: '你最想用 AI 解决的具体工作问题是什么？' },
  { id: 'vote', label: '最想优先突破哪个方向？', group: '现场投票 · 选出重点', prompt: '你目前最想优先突破哪个方向？' },
  { id: 'next', label: '这三天，你还想学什么？', group: '三天学习 · 期待补充', prompt: '接下来的三天，你还想带走哪些方法和成果？' },
  { id: 'class', label: '对这堂课，有什么建议？', group: '课堂建议 · 及时反馈', prompt: '怎样调整课堂，会更有助于你学会并用起来？' },
  { id: 'course', label: '希望课程增加哪些内容？', group: '课程建议 · 持续改进', prompt: '为了更好地解决企业问题，你希望课程增加什么内容？' }
];
export const topic = id => topics.find(t => t.id === id) || topics[1];

// ===== 学员问题墙数据 =====
export const posts = reactive([
  { id: 'p1', uid: 's1', author: '王敏', role: '财务经理', industry: '制造业', topic: 'lesson', title: '费用分析做了很多，怎样让业务部门真正采取行动？', body: '我们每月都有部门费用分析表，但汇报后，业务负责人往往只看总额，很少继续落实改进。\n\n现在卡在：财务知道费用超了，却很难把原因讲清楚，更难把责任和行动对应到具体岗位。\n\n我希望这节课能学会从差异分析走到行动建议，最好能有一份可以直接练习的 Excel 和沟通案例。', goal: '形成可执行的经营建议', resonance: 6, replies: [{ id: 'r1', author: '李老师', kind: 'teacher', body: '这个问题会放到今天的案例里。我们先用费用审批职责清单，把“差异—原因—责任人—动作”串起来，再练习怎样与业务沟通。', target: '' }, { id: 'r2', author: '赵磊', kind: 'student', body: '我们也遇到过。先和业务一起确认差异原因，再让负责人写下一项能执行的动作，会比只发报表更容易推进。', target: '王敏' }] },
  { id: 'p2', uid: 's2', author: '赵磊', role: '财务主管', industry: '商贸业', topic: 'work', title: '回款周期越来越长，怎么用现有数据找到最需要跟进的客户？', body: '目前每周手工合并应收台账，销售、财务使用的客户名称还不统一。希望能先整理出可靠的账龄，再形成每周的回款跟进清单。', goal: '建立回款跟进清单', resonance: 3, replies: [] },
  { id: 'p3', uid: 's3', author: '刘佳', role: '财务经理', industry: '制造业', topic: 'enterprise', title: '预算总是财务自己编，怎样让业务负责人愿意一起做？', body: '企业有年度预算，但业务部门觉得这只是财务的表格。编制时参与不多，执行时也缺少复盘。最大的卡点是部门目标没有和预算动作对应起来。', goal: '推动业务参与预算', resonance: 5, replies: [{ id: 'r3', author: '周老师', kind: 'teacher', body: '先把部门目标和关键业务动作拆出来，再讨论需要哪些资源。预算模板可以帮助表达，但要从业务目标开始。', target: '' }] },
  { id: 'p4', uid: 's4', author: '周宁', role: '财务主管', industry: '服务业', topic: 'ai', title: '每月要合并十几张 Excel，想用 AI 减少重复整理。', body: '不同部门交来的表头、日期和分类不一致，每月整理占用很多时间。希望学会先把数据标准化，再用 AI 辅助合并和发现异常。', goal: '减少数据整理时间', resonance: 7, replies: [{ id: 'r4', author: '林悦', kind: 'student', body: '我们也想学这个，尤其是先统一字段和分类的步骤。', target: '周宁' }] },
  { id: 'p5', uid: 's5', author: '林悦', role: '经营管理者', industry: '零售业', topic: 'next', title: '这三天还想练习现金流预测，能不能安排一个完整案例？', body: '希望把销售、回款、采购付款联系起来，做一个未来几周的现金流预测，最后能带走一份自己的练习成果。', goal: '完成现金流预测练习', resonance: 6, replies: [] },
  { id: 'p6', uid: 's6', author: '张玲', role: '财务主管', industry: '服务业', topic: 'class', title: '希望老师演示 Excel 时，可以边看课件边跟着操作。', body: '有些操作讲得很快，想在课程资料里随时找到同一版本的文件，回去后还能继续练习。', goal: '课上跟练课后复习', resonance: 5, replies: [] },
  { id: 'p7', uid: 's7', author: '许航', role: '财务经理', industry: '制造业', topic: 'course', title: '希望增加走进企业后如何做第一次财务管理诊断的案例。', body: '想知道第一次访谈老板和业务负责人应该问什么、看哪些数据，以及怎样判断先从哪里切入。', goal: '掌握企业诊断切入方法', resonance: 6, replies: [] },
  { id: 'p8', uid: 's8', author: '宋洁', role: '财务主管', industry: '商贸业', topic: 'work', title: '经营报表口径经常变，如何和业务统一指标定义？', body: '同一项收入，业务按订单、财务按确认时间，各自的报表难以比较。希望能建立一份双方认可的指标口径清单。', goal: '统一经营指标口径', resonance: 4, replies: [] }
]);
export const voteOptions = ['经营分析与财务 BP', '全面预算落地', '企业财税风险管理', 'AI 数据分析', '内控与流程改善'];
export const votes = reactive(new Map([['s1', 0], ['s2', 1], ['s3', 1], ['s4', 3], ['s5', 0], ['s6', 3], ['s7', 2], ['s8', 4]]));
export const liked = reactive(new Set());

// ===== 课程资料 =====
export const files = [
  { id: 'excel', name: '费用审批职责清单.xlsx', kind: 'XLSX', chapter: '2', desc: '第 2 讲 · 课堂跟练 · 含填写说明' },
  { id: 'slides', name: '费用流程与经营协同课件.pdf', kind: '课件', chapter: '2', desc: '第 2 讲 · 老师授课演示' },
  { id: 'workbook', name: '企业业务流程访谈表.xlsx', kind: 'XLSX', chapter: '1', desc: '第 1 讲 · 场景访谈与资料准备' },
  { id: 'action', name: '经营分析行动建议练习.pdf', kind: 'PDF', chapter: '3', desc: '第 3 讲 · 分析到行动的练习' }
];

// ===== 本省开课 =====
export const schedules = [
  { id: 'c1', province: '湖北省', type: '训练营课', name: '财税BP训练营', month: '10月', day: '24', time: '2026.10.24—10.26　09:00—17:00', campus: '武汉 · 汉口示例校区', address: '校区示例地址，正式位置以 CRM 排课为准', status: '即将开课' },
  { id: 'c2', province: '湖北省', type: '宣讲课', name: 'AI 时代财务岗位能力宣讲课', month: '10月', day: '28', time: '2026.10.28　19:00—21:00', campus: '武汉 · 武昌示例校区', address: '校区示例地址，正式位置以 CRM 排课为准', status: '即将开课' },
  { id: 'c3', province: '湖北省', type: '财税管理速成课程', name: '企业财务管理速成课程', month: '11月', day: '02', time: '2026.11.02—11.04　09:00—17:00', campus: '宜昌 · 示例校区', address: '校区示例地址，正式位置以 CRM 排课为准', status: '即将开课' },
  { id: 'c4', province: '湖北省', type: '训练营课', name: '全面预算训练营', month: '11月', day: '07', time: '2026.11.07—11.09　09:00—17:00', campus: '襄阳 · 示例校区', address: '校区示例地址，正式位置以 CRM 排课为准', status: '即将开课' },
  { id: 'c5', province: '广东省', type: '训练营课', name: 'AI数据分析训练营', month: '10月', day: '25', time: '2026.10.25—10.27　09:00—17:00', campus: '广州 · 示例校区', address: '校区示例地址，正式位置以 CRM 排课为准', status: '即将开课' },
  { id: 'c6', province: '广东省', type: '财税管理速成课程', name: '企业财务管理速成课程', month: '11月', day: '03', time: '2026.11.03—11.05　09:00—17:00', campus: '深圳 · 示例校区', address: '校区示例地址，正式位置以 CRM 排课为准', status: '即将开课' },
  { id: 'c7', province: '广东省', type: '宣讲课', name: '财税管理实战宣讲课', month: '11月', day: '06', time: '2026.11.06　19:00—21:00', campus: '佛山 · 示例校区', address: '校区示例地址，正式位置以 CRM 排课为准', status: '即将开课' }
];

// ===== 任务 / 作业 / 测试公共数据 =====
export const lessonNames = ['理解企业业务', '费用流程与经营协同', '分析与行动建议', '预算与业务目标', '经营数据口径', '责任岗位与协作', '业务访谈与诊断', '财务分析表达', '风险识别与跟进', '跨部门沟通', '成果复盘', '综合实战'];
export const rubric = [['成果完整性', 20], ['业务与数据准确性', 30], ['分析思路', 30], ['应用与表达', 20]];
export const quizBank = [
  { title: '费用分析完成后，怎样让结论更容易被业务部门执行？', options: ['只发送费用明细表', '明确行动、责任岗位与复盘时间', '只增加更多图表'], answer: 1, analysis: '分析应形成可以跟进的行动建议，明确由谁负责、何时复盘。', source: '第 2 讲课件 · 从分析到行动' },
  { title: '不同部门对同一个经营指标理解不一致，第一步应怎样处理？', options: ['先统一指标定义、范围和数据来源', '直接比较结果并排名', '由财务独自决定所有业务动作'], answer: 0, analysis: '先统一数据口径，再讨论差异与行动，避免用不同定义得出结论。', source: '第 2 讲职责清单 · 数据口径' },
  { title: '开展费用差异分析时，哪种信息更有助于定位业务原因？', options: ['只有费用总额', '只有上月同比', '费用变化对应的业务量、单价和具体场景'], answer: 2, analysis: '把财务变化与业务场景关联，才能进一步核实差异原因。', source: '第 2 讲课件 · 差异分析练习' }
];
export const clone = v => JSON.parse(JSON.stringify(v));
export const sampleFiles = {
  xlsx: { name: '费用差异分析与行动清单.xlsx', kind: 'xlsx', size: '48 KB', sample: true, status: 'ready' },
  pptx: { name: '经营分析沟通汇报.pptx', kind: 'pptx', size: '1.2 MB', sample: true, status: 'ready' },
  docx: { name: '业务访谈与改进建议.docx', kind: 'docx', size: '36 KB', sample: true, status: 'ready' }
};

// ===== 页面级状态（对应原型 st） =====
export const st = reactive({
  topic: 'all', sort: 'latest', selected: 'p1', classOpen: true, role: 'student',
  province: '湖北省', scheduleType: 'all', replyTo: '', file: 'excel', fileFilter: 'all', voted: false
});

// 自增 id（对应原型 newId/fileSeq，从 20 起：新问题 newNN、新回复 rNN、文件 fNN…）
let newId = 20;
export function nextId() {
  return newId++;
}
let fileSeq = 0;
export function nextFileId() {
  return ++fileSeq;
}

// ===== toast（原型底部提示条，切换页面时隐藏） =====
export const toastState = reactive({ text: '', visible: false });
export function showToast(s) {
  toastState.text = s;
  toastState.visible = true;
}
export function hideToast() {
  toastState.visible = false;
}

// ===== 任务 / 作业 / 测试（对应原型 edu） =====
export const edu = reactive({
  lesson: 'all', filter: 'all', currentTask: 'a1', assignmentOpen: true, quizOpen: true, uploadFault: false, quizFault: false,
  tasks: [
    { id: 'a1', kind: 'practice', lesson: 2, title: '把费用差异变成业务行动建议', brief: '结合一个已脱敏的企业场景，比较计划与实际费用，说明主要差异及业务原因。\n请提交费用分析 Excel，并用文字说明 3 项改进行动、责任岗位与复盘时间；也可附上汇报 PPT 或建议 Word。', max: 100, due: '2026-10-21 18:00' },
    { id: 'a2', kind: 'practice', lesson: 3, title: '完成一份企业业务访谈与诊断建议', brief: '围绕工作中的一个真实协同卡点，整理访谈对象、问题、证据和行动建议。\n请提交脱敏后的 Word 访谈记录或 PPT 诊断方案，并说明最希望老师点评的部分。', max: 100, due: '2026-10-22 18:00' },
    { id: 'q1', kind: 'quiz', lesson: 2, title: '费用流程与经营协同课堂测试', due: '2026-10-21 18:00' }
  ],
  answers: {}, questions: clone(quizBank), quizVersion: 1, quizAnswers: {}, quizResult: null, quizPending: false, quizAttempts: [],
  scores: [
    { id: 'past-a', student: '陈晨', title: '企业业务链梳理作业', kind: 'practice', score: 92, max: 100, version: 1, submission: 1, feedback: '业务链条完整，建议补充关键岗位之间的信息交接方式。', state: 'success' },
    { id: 'past-q', student: '陈晨', title: '第 1 讲基础应用测试', kind: 'quiz', score: 20, max: 30, version: 1, submission: 1, feedback: '已按老师审核的答案自动计分，可回看本次解析。', state: 'failed' }
  ]
});

export function taskFor(id = edu.currentTask) {
  return edu.tasks.find(t => t.id === id) || edu.tasks[0];
}
export function answerFor(id = edu.currentTask) {
  if (!edu.answers[id]) edu.answers[id] = { text: '', files: [], versions: [], saved: false };
  return edu.answers[id];
}
export function lastSubmission(id = edu.currentTask) {
  const a = edu.answers[id];
  return a ? a.versions[a.versions.length - 1] : undefined;
}
export function currentGrade(id = edu.currentTask) {
  const v = lastSubmission(id);
  return v ? edu.scores.find(g => g.id === 'chen-' + id + '-' + v.version) : null;
}
export function participants() {
  return new Set([...posts.map(p => p.uid), ...votes.keys()]).size;
}
export function isWritable() {
  return st.role === 'teacher' || st.classOpen;
}

// 添加成果文件（对应原型 addFile；fail 用于演示上传失败）
export function addFile(kind, fail = false) {
  const f = { ...clone(sampleFiles[kind]), id: 'f' + nextFileId(), status: fail ? 'failed' : 'ready' };
  answerFor().files.push(f);
  return f;
}

// 申请成绩复核（对应原型 data-review）
export function applyReview(g) {
  if (!g || g.review) return;
  g.review = true;
  showToast('复核申请已关联该成绩与答案版本（演示），原分数保留。');
}

// ===== 课堂互动开关状态 =====
export function setTopic(id) {
  st.topic = id;
}

// ===== 课程测试提交（对应原型 submitQuiz） =====
export function submitQuiz() {
  if (edu.quizResult || !edu.quizOpen) return null;
  if (Object.keys(edu.quizAnswers).length !== edu.questions.length) {
    return '还有未作答的题目，请完成后提交。';
  }
  if (edu.quizFault) {
    edu.quizFault = false;
    edu.quizPending = true;
    return null;
  }
  const correct = edu.questions.reduce((s, q, i) => s + Number(edu.quizAnswers[i] === q.answer), 0);
  const r = {
    id: 'quiz-' + edu.quizVersion, student: '陈晨', kind: 'quiz', title: taskFor('q1').title,
    correct, score: correct * 10, max: edu.questions.length * 10, version: 1, submission: edu.quizVersion,
    feedback: '按老师审核的标准答案自动计分。', state: 'pending'
  };
  edu.quizResult = r;
  edu.quizPending = false;
  edu.quizAttempts.push({ ...clone(r), questions: clone(edu.questions), answers: clone(edu.quizAnswers) });
  if (!edu.scores.some(g => g.id === r.id)) edu.scores.unshift(r);
  return r;
}

// ===== 页面 id → 路由映射 =====
export const PAGE_ROUTES = {
  wall: '/practicalClass/wall',
  detail: '/practicalClass/detail',
  tasks: '/practicalClass/tasks',
  assignment: '/practicalClass/assignment',
  quiz: '/practicalClass/quiz',
  resources: '/practicalClass/resources',
  schedules: '/practicalClass/schedules',
  scores: '/practicalClass/scores',
  entry: '/practicalClass/entry',
  courseBelong: '/practicalClass/courseBelong'
};
export const ROUTE_PAGES = Object.fromEntries(Object.entries(PAGE_ROUTES).map(([k, v]) => [v, k]));
